// Builders
import buildCartTrackingData from "./builders/buildCartTrackingData";

// Classes
import { CartTrackingData } from "./classes/CartTrackingData";

function trackReservationClick(
	eventName: string,
	quantity: number,
	prestIds: string[],
	prestNames: string[],
	itemPriceAti: string,
	beginDate: string,
	endDate: string,
	duration: number
): void {
	const cartTrackingData: CartTrackingData = buildCartTrackingData(
		quantity,
		prestIds,
		prestNames,
		itemPriceAti,
		beginDate,
		endDate,
		duration
	);

	// @ts-ignore
	window.dataLayer.push(cartTrackingData);
	// @ts-ignore
	window.dataLayer.push({ event: eventName });
}

export default trackReservationClick;
